import IconCalendarDaysSolid from '@/assets/icons/font_awesome/calendar-days-solid.svg?react';
import IconCompassSolid from '@/assets/icons/font_awesome/compass-solid.svg?react';
import IconCreditCardSolid from '@/assets/icons/font_awesome/credit-card-solid.svg?react';
import IconGearsSolid from '@/assets/icons/font_awesome/gears-solid.svg?react';
import IconMoneyBillTransferSolid from '@/assets/icons/font_awesome/money-bill-transfer-solid.svg?react';
import IconShareSolid from '@/assets/icons/font_awesome/share-solid.svg?react';
import IconUserGearSolid from '@/assets/icons/font_awesome/user-gear-solid.svg?react';
import IconUserPlusSolid from '@/assets/icons/font_awesome/user-plus-solid.svg?react';
import { ICON__lock } from '@/assets/icons_fa';
import { EPagesMobileTabs } from '@/enums/EPagesMobileTabs';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { LayoutPageMobileWithTabs } from '@/layouts/LayoutPageMobileWithTabs';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { TabsContent } from '@radix-ui/react-tabs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonSettingsWorkspaceTab } from './ButtonSettingsWorkspaceTab';
import { ESettingsWorkspaceTab } from './ESettingsWorkspaceTab';
import { TabSettingsWorkspaceCreditsTopUp } from './credits_top_up/TabSettingsWorkspaceCreditsTopUp';
import { TabSettingsWorkspaceCreditsTransactions } from './credits_transactions/TabSettingsWorkspaceCreditsTransactions';
import { TabSettingsWorkspaceFeaturesAccess } from './features_access/TabSettingsWorkspaceFeaturesAccess';
import { TabSettingsWorkspaceGeneralEdit } from './general_edit/TabSettingsWorkspaceGeneralEdit';
import { TabSettingsWorkspaceSharedEntities } from './shared_entities/TabSettingsWorkspaceSharedEntities';
import { TabSettingsWorkspaceSubscription } from './subscription/TabSettingsWorkspaceSubscription';
import { TabSettingsWorkspaceUserInvitationsShared } from './user_invitation/TabSettingsWorkspaceUserInvitationsShared';

export function PageSettingsWorkspaceViewsMobile() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const [activeTab, setActiveTab] = useState(EPagesMobileTabs.SETTINGS_NAVIGATION);

  //FIELDS
  /*
   * HTML
   */
  return (
    <LayoutPageMobileWithTabs
      tabs={[EPagesMobileTabs.SETTINGS_NAVIGATION, EPagesMobileTabs.SETTINGS_PARAMS]}
      icons={[<IconCompassSolid />, <IconUserGearSolid />]}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    >
      <TabsContent className={`bg-component mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.SETTINGS_NAVIGATION}>
        <div className="flex flex-col gap-4 px-2 overflow-y-auto bg-component  pt-4">
          <ButtonSettingsWorkspaceTab setActiveTab={setActiveTab} type={ESettingsWorkspaceTab.GENERAL} Icon={IconGearsSolid} />
          <ButtonSettingsWorkspaceTab setActiveTab={setActiveTab} type={ESettingsWorkspaceTab.CREDITS_TOP_UP} Icon={IconCreditCardSolid} />
          {!workspace_current.is_personal && (
            <ButtonSettingsWorkspaceTab setActiveTab={setActiveTab} type={ESettingsWorkspaceTab.FEATURES_ACCESS} Icon={ICON__lock} />
          )}
          <ButtonSettingsWorkspaceTab setActiveTab={setActiveTab} type={ESettingsWorkspaceTab.SHARED_ENTITIES} Icon={IconShareSolid} />
          <ButtonSettingsWorkspaceTab setActiveTab={setActiveTab} type={ESettingsWorkspaceTab.CREDITS_TRANSACTIONS} Icon={IconMoneyBillTransferSolid} />
          <ButtonSettingsWorkspaceTab setActiveTab={setActiveTab} type={ESettingsWorkspaceTab.USERS} Icon={IconUserPlusSolid} />
          <ButtonSettingsWorkspaceTab setActiveTab={setActiveTab} type={ESettingsWorkspaceTab.SUBSCRIPTION} Icon={IconCalendarDaysSolid} />
        </div>
      </TabsContent>
      <TabsContent className={`bg-component mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.SETTINGS_PARAMS}>
        <TabSettingsWorkspaceGeneralEdit />
        <TabSettingsWorkspaceCreditsTopUp />
        <TabSettingsWorkspaceFeaturesAccess />
        <TabSettingsWorkspaceSharedEntities />
        <TabSettingsWorkspaceCreditsTransactions />
        <TabSettingsWorkspaceUserInvitationsShared />
        <TabSettingsWorkspaceSubscription />
      </TabsContent>
    </LayoutPageMobileWithTabs>
  );
}
